export function DocumentsDateFilter({ dateFilter, setDateFilter }) {
  return (
    <select
      data-testid="documents-date-filter"
      value={dateFilter}
      onChange={(event) => setDateFilter(event.target.value)}
      className="h-9 cursor-pointer rounded-sm border border-zinc-800 bg-zinc-900/50 px-3 text-sm text-white focus:border-white focus:outline-none focus:ring-0"
    >
      <option value="all">Toutes les dates</option>
      <option value="today">Aujourd'hui</option>
      <option value="week">7 derniers jours</option>
      <option value="month">30 derniers jours</option>
      <option value="year">Cette année</option>
    </select>
  );
}
